var map = {
	"./BOARD.svg": "bc69",
	"./CALENDAR.svg": "23cb0",
	"./CARDS.svg": "4c40",
	"./CHARTS.svg": "444b",
	"./EYE.svg": "e778",
	"./HIDE.svg": "e027",
	"./TABLE.svg": "8b34",
	"./TIMELINE.svg": "48bb",
	"./active/BOARD.svg": "ee5e",
	"./active/CALENDAR.svg": "3e0c",
	"./active/CARDS.svg": "ff66",
	"./active/CHARTS.svg": "1581",
	"./active/TABLE.svg": "4505",
	"./active/TIMELINE.svg": "7cd0",
	"./gallery.svg": "d273",
	"./layoutselect.svg": "9770"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c7b9";